module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-items-icon-next-da3f75ef509a208ff565a5368e5aa0a4.svg";